import vars from '../_export.module.scss';

export const HEADER_HEIGHT = vars.headerHeight;
